import { ClockIcon } from '@phosphor-icons/react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'app/components/ui/dropdown-menu'
import { SNOOZE_OPTIONS } from './responseQueue'

export function SnoozeControl({ onSnooze }: { onSnooze: (until: Date) => void }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Snooze"
          title="Snooze"
          className="flex h-7 w-7 items-center justify-center rounded-full text-subtle transition hover:bg-surface-muted hover:text-strong data-[state=open]:bg-surface-muted data-[state=open]:text-default"
        >
          <ClockIcon size={15} weight="bold" />
        </button>
      </DropdownMenuTrigger>
      {/* Portalled on purpose: the list scrolls, and a menu positioned inside the scroller is clipped by it. */}
      <DropdownMenuContent align="end" className="w-44">
        {SNOOZE_OPTIONS.map((option) => (
          <DropdownMenuItem key={option.label} onSelect={() => onSnooze(option.at())}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
